import React from 'react'
import { QuickTable, QuickTableCellProps, QuickTableHeaders } from 'react-ui-scaffold'
import ChargeHoursCell from '../../../components/QuickTableCells/ChargeHoursCell'
import DeleteCell from '../../../components/QuickTableCells/DeleteCell'
import './TimesheetChargeTable.css'

interface Props{
	charges: any[],
	loading?: boolean,
	onDelete(id:string):any
}

export default function TimeshetChargeTable({ charges, loading, onDelete }:Props) {
	
	const headers: QuickTableHeaders = {
		chargeCode: { title: 'Charge Code', width: 200, component: ({ cell }: QuickTableCellProps) => <>{cell.name}</> },
		reportingMonth: { title: 'Month', width: 200 },
		hours: { title: 'Hours', width: 150, component: ChargeHoursCell },
		notes: { title: 'Notes', width: 300 },
		delete: {
			title: '',
			width: 100,
			component: DeleteCell,
			props: {
				onDelete: onDelete,
			},
		},
	}
	
	if ((charges.length === 0) && (!loading)) {
		return <div className="ChargeTable">
			<div className='noCharges'>
				You have no charges to display
			</div>
		</div>
	}

	return (
		<div className="ChargeTable">
			<QuickTable
				data={charges}
				headers={headers}
				primaryKey={'_id'}
				hover
			/>
		</div>
	)
}
